import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {SoundState} from './types';

export const actions: ActionTree<SoundState, RootState> = {

  async getCallSounds({commit, dispatch}, data) {
    try {
      let resp = await axios({
        url: '/lk-api/call/sounds',
        params: data,
      });
      commit('setCallSounds', resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },

  async getCallSoundsPlay({commit, dispatch}, data) {
    try {
      let resp = await axios({
        url: '/lk-api/call/sounds/play',
        params: data,
      });
      return resp.data;
    } catch (err) {
      throw err;
    }
  },

  async saveCallSound({commit, dispatch}, data) {
    try {
      let resp = await axios({
        method: 'post',
        url: '/lk-api/call/sounds',
        data: data,
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },

  async deleteCallSound({commit, dispatch}, data) {
    try {
      let resp = await axios({
        method: 'delete',
        url: '/lk-api/call/sounds',
        data: data,
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },

  async getIvrMenu({commit, dispatch}, data) {
    try {
      let resp = await axios({
        url: '/lk-api/call/ivr',
        params: data,
      });
      commit('setIvrMenu', resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },

};